﻿myApp.directive('morep', function () {
    return {
        link: function (scope, elm) {
            if (scope.$last) {
                elm.on("load", function () {
                    scope.start();
                });
            }
        }
    }
});

myApp.controller("moreCtrl", ['$scope', '$http', function ($scope, $http) {
    if ($scope.lang == "heb") {
        $scope.headline = "פרויקטים נוספים";
    }
    else {
        $scope.headline = "More Projects";
    }
    $scope.slides = $scope.projects_slide;
    $scope.isImgloaded = false;
    $scope.start = function () {
        var owl = $('.owl-carousel');
        owl.owlCarousel({
            loop: true,
            margin: 10,
            responsive: {
                0: {
                    items: 1
                },
                1000: {
                    items: 6
                }
            }
        });
    }
    $scope.moveLeft = function () {
        var owl = $('.owl-carousel');
        owl.trigger('prev.owl.carousel', [300]);
    }
    $scope.moveRight = function () {
        var owl = $('.owl-carousel');
        owl.trigger('next.owl.carousel');
    }
}]);




//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/moreprojects.js
// module id = 15
// module chunks = 0